import { Toggle } from '@pandiafi/components'
import { Field, FieldProps, useFormikContext } from 'formik'
import { t } from 'i18next'
import React, { useEffect, useState } from 'react'

import FormFieldWrapper from 'components/FormField'
import { FormValues } from 'views/TerminateContract/TerminateForm/initialValues'

export const GivingContactInfoAllowedField = () => {
  const { values, setFieldValue } = useFormikContext<FormValues>()
  const [previousDisplaysSelf, setPreviousDisplaysSelf] = useState(
    values.displaysSelf
  )

  useEffect(() => {
    if (values.displaysSelf && !previousDisplaysSelf) {
      setFieldValue('givingContactInfoAllowed', true)
    }
    setPreviousDisplaysSelf(values.displaysSelf)
  }, [values.displaysSelf, previousDisplaysSelf, setFieldValue])

  return (
    <Field name="givingContactInfoAllowed">
      {(props: FieldProps<FormValues['givingContactInfoAllowed']>) => {
        const { field, meta, form } = props
        return (
          <FormFieldWrapper name={field.name} meta={meta} labelBold>
            <Toggle
              checked={meta.value}
              labelPosition="left"
              onChange={(value) => form.setFieldValue(field.name, value)}
            >
              {t('terminateContract:labels.givingContactInfoAllowed')}
            </Toggle>
          </FormFieldWrapper>
        )
      }}
    </Field>
  )
}
